var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"item"},[_vm._v("由杭州亿尚智能科技有限公司提供技术支持")]),_c('div',{staticClass:"item"},[_vm._v("© 2017-"+_vm._s(_vm.currentYear)+" 杭州亿尚智能科技有限公司 版权所有 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }